import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IResponseOption, IRoleEnum } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IRoleEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.userRoles");

export const userRoles = {
  ...getAllApis,
};
